/*

TESTED:

    - IE11, IE10, IE10, IE9
    - Chrome
    - Firefox

EXAMPLE:

	var editor = new XMLEditor();
	if( editor.setXMLString( INPUT ))
	{
		if( editor.changeOrCreateElement( 'active', 'false' ))
		{
			var editedXMLAsString = editor.getXML();
			if( editedXMLAsString )
			{
				console.log(editedXMLAsString);
			}
		}
	}

 */

export const XMLEditor = function()
{
    this.object = null;
    this.savedHeader = ''; // IE does not output <?xml ?> tag
};

XMLEditor.prototype.setXMLString = function( XMLAsString )
{
    // https://developer.mozilla.org/en-US/docs/Web/Guide/Parsing_and_serializing_XML
    var object;

    try
    {
        object = new DOMParser().parseFromString(XMLAsString, 'application/xml');

        if( object.documentElement.nodeName == "parsererror" )
        {
            object = null;
        }
    }
    catch(_)
    {
        object = null;
    }

    if( object )
    {
        var header_matches = XMLAsString.match(/(<[?]xml[^>]*>)/gi);
        if( header_matches )
        {
            this.savedHeader = header_matches[0];
        }
        else
        {
            this.savedHeader = '';
        }

        this.object = object;
        return true;
    }
    else
    {
        return false;
    }
};

XMLEditor.prototype.getXML = function()
{
    // https://developer.mozilla.org/en-US/docs/Web/Guide/Parsing_and_serializing_XML
    try
    {
        var serializer = new XMLSerializer();
        var string = serializer.serializeToString( this.object );
        if( string )
        {
            if( string.match(/<[?]xml/gi))
            {
                return string;
            }
            else
            {
                return this.savedHeader + string;
            }
        }
        else
        {
            return null;
        }
    }
    catch( _ )
    {
        return null;
    }
};

XMLEditor.prototype.changeOrCreateElement = function( elementName, value )
{
    var childArray = this.object.documentElement.getElementsByTagName( elementName );
    var child;
    if( childArray && childArray.length > 0 )
    {
        child = childArray[0];
        child.textContent = value;
    }
    else
    {
        child = this.object.createElement( elementName );
        if( child )
        {
            this.object.documentElement.appendChild( child );
            child.textContent = value;
        }
        else
        {
            return false;
        }
    }
    return true;
};


// WEBPACK FOOTER //
// ./src/Atollon/utilities/XmlEditor.js